const defaultState = {
  title: 'Style Theory Careers',
}

// actions
const SET_TITLE = 'st-career/global/SET_TITLE'
const RESET_TITLE = 'st-career/global/RESET_TITLE'

// reducer
export default function (state = defaultState, action) {
  switch (action.type) {
    case SET_TITLE: {
      const newTitle = action.title

      if (newTitle.startsWith(defaultState.title)) {
        return newTitle
      }

      return {
        title: newTitle + ' - ' + defaultState.title,
      }
    }

    case RESET_TITLE: {
      return { title: defaultState.title }
    }

    default: {
      return state
    }
  }
}

// Action Creators
export function setTitle (title) {
  return { type: SET_TITLE, title }
}

export function resetTitle () {
  return { type: RESET_TITLE }
}
